﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class task extends IceEntity {
    task_key: string = "";
    patient_trans_account: string = "";
    recurrence_key: string = "";
    task_type: IceTypes.task_type = IceTypes.task_type.tasktypeOther;
    trans_account: string = "";
    account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    subject: string = "";
    note: string = "";
    start_date: any = NaN;
    due_date: any = NaN;
    from_login_user_name: string = "";
    to_login_user_name: string = "";
    complete: boolean = false;
    reminder_key: string = "";
    record_version: number = 0;
    offline_record_status: number = 0;
    accessed: any = NaN;
    accessed_user: string = "";
    created: any = NaN;
    created_user: string = "";
    modified: any = NaN;
    modified_user: string = "";

    gettablename(): string {
        return "TASK";
    }
}
